import React, { Component } from 'react'
import { connect } from 'react-redux';
import { Segment, Message, Header, Icon, Popup, Button } from 'semantic-ui-react';
import { loadPendingApprovalUsers } from '../../../store/actions/userActions';
import DataTable from '../../common/DataTable';

const columns = [
    { title: 'User ID', data: 'id' },
    { title: 'Company Name', data: 'companyName' },
    { title: 'Company Type', data: 'companyTypeText' },
    { title: 'Purchase Company', data: 'purchaseCompanyName' },
    { title: 'Country', data: 'countryText' },
    { title: 'Contact Person', data: 'contactPerson' },
    { title: 'Contact Number', data: 'contactNumber' },
    { title: 'Email', data: 'email' },
    { title: 'Registration Source', data: 'registrationSourceText' }
]

class PendingApproval extends Component {
    componentDidMount() {
        this.props.loadPendingApprovalUsers();
    }

    refreshReport = () => {
        this.props.loadPendingApprovalUsers();
    }

    render() {
        const { loading, loadError, errorMsg, errorMsgData, pendingApprovalUsers } = this.props.users;

        return (
            <Segment loading={loading}>
                <Header as='h3'>
                    <Icon name='th list' />
                    <Header.Content>
                        Pending Approval Users
                    </Header.Content>
                </Header>
                <Popup position='left center' content='Refresh data' trigger={<Button color='black' onClick={() => this.refreshReport()} size='massive' style={{ position: 'fixed', right: '10px', bottom: '30px', zIndex: 100 }} circular icon='sync alternate' />} />
                {
                    loadError &&
                    <Message negative>
                        <Message.Header>Error loading gift data</Message.Header>
                        <p>{errorMsg}</p>
                        <p>{errorMsgData}</p>
                    </Message>
                }
                {
                    (Array.isArray(pendingApprovalUsers) && pendingApprovalUsers.length > 0) ?
                    <DataTable data={pendingApprovalUsers} columns={columns} />
                    :
                    <p>No records available</p>
                }
                
            </Segment>
        )
    }
}

const mapStateToProps = (state) => {
    return {
        users: state.users
    }
}

export default connect(mapStateToProps, { loadPendingApprovalUsers })(PendingApproval);